import { HttpService } from '@/app/shared/services/http.service';
import { UserComments } from '@/app/shared/types/userComments.type';
import { environment } from '@/environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommentsService {
  constructor(private readonly httpService: HttpService<UserComments>) {}

  public createComment(comment: UserComments): Observable<UserComments> {
    const endpoint = `${environment.api.feedback}`;
    return this.httpService.post(endpoint, comment);
  }
}
